<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500" persistent>
      <template v-slot:activator="{ on, attrs }">
        <v-btn small v-bind="attrs" v-on="on" color="success">Open</v-btn>
        <!-- <v-btn
          color="red lighten-2"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Click Me
        </v-btn> -->
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Phone Number List
        </v-card-title>

        <v-card-text>
          <v-layout row wrap>
            <v-flex>
              <v-textarea name="input-7-1" label="Phone Number" v-model="phoneNumber" hint="Hint text"></v-textarea>
              <!-- <v-text-field autofocus v-model="phoneNumber" @click="addToList" label="Phone Number">
              </v-text-field> -->
            </v-flex>
            <v-flex shrink>
              <v-btn color="success" @click="addToList">Add</v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-text>
          <v-list two-line style="height: 350px; overflow: auto;" dense>
            <template v-for="(item, index) in List">

              <v-list-tile :key="index" avatar>
                <v-list-tile-avatar>
                  <v-btn color="info" fab class="ma-0 pa-0" small><v-icon>mdi-delete</v-icon></v-btn>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title v-html="item"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          {{ List.length }} Numbers
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'edit-number',
  props: ['metadata'],
  data() {
    return {
      dialog: false,
      phoneNumber: null,
      List: [],
    }
  },
  methods: {
    addToList() {
      console.log('phoneNumber', this.phoneNumber)

      const numberArray = this.phoneNumber.split("\n")
      // .join("\n")

      console.log('formattedString', numberArray, typeof (this.List), typeof (numberArray))
      const list = []
      Promise.all(
        numberArray.map((number) => {

          const found = this.List.find(element => element === number);

          if (!found) {
            this.List.push(number)
          }
        })
      )

      console.log('listlistlistlist', list)

      // this.List.concat(list);
      // if (this.List.length === 0) {
      //   this.List = list
      // } else {
      //   this.List.concat(list);
      //   console.log('type', typeof (this.List), this.List)
      // }


      console.log('afterafterafter', this.List)

      this.$swal
        .mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        })
        .fire({
          type: "success",
          title: `Number was added`
        });

      // this.List.push(formattedString)
    }
  }
}
</script>

<style scoped>

</style>